import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateHasNull',
})
export class DateHasNullPipe implements PipeTransform {
  transform(value: Date): boolean {
    return value?.toString().includes('00:00:00');
  }
}
